<p-dialog
  *ngFor="let call of calls ; let i = index"
  [visible]="true"
  [draggable]="true"
  [resizable]="true"
  [modal]="false"
  [maximizable]="true"
  [closable]="false"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '90%',left: i * 50 + 'px', top: i * 50 + 'px' }"
  [showHeader]="true"
  [styleClass]="'call-receiving-dialog callcard-'+ call?.callId"
>
  <ng-template pTemplate="header">
    <div (click)="bringToFront(i,call)" role="button"  tabindex="-1" [class]="'call-head no-select'">
      <div class="head-left">
        <div class="call-id-number">
          <span>{{ call.callId }}</span>
          <span>CA#{{ call.card.id }}</span>
        </div>
        <div class="callid-info ms-5">
          <div class="d-flex-between">
            <img class="icon-queue" src="/assets/theme/w3crm/icons/svgs/queue.svg" alt=""/>
            <span *ngIf="call.callType"
                  class="head-queue-text">{{ call.queue?.valueObject?.name?.value }}
              - {{ call.queue?.valueObject?.description?.value }}</span>
            <small class="badge badge-sm badge-info ms-2"
                   [class.badge-danger]="call.callType=='INBOUND'">{{ 'general.' + call.callType | translate }}</small>
          </div>
          <div class="phone-wrapper">
            <img class="icon-pad" src="/assets/theme/w3crm/icons/svgs/num-pad.svg" alt=""/>
            <span class="head-phone-text">
              {{ call.phone }}
            </span>
            <i
              class="fas fa-copy copy-icon"
              role="button"
              title="Kopyala"
              (click)="copyPhone(call.phone)">
            </i>
          </div>
        </div>
      </div>

      <div class="header-right">
        <div class="patient-related-category">
          <ng-container *ngFor="let category of uniqueCategoriesByName">
          <span [class]="category?.valueObject?.class?.value">
            {{ category?.valueObject?.name?.value }}
          </span>
          </ng-container>
        </div>
        <div class="head-between-line"></div>
        <div class="head-call-datetime-text">
          <small class="date">10.01.2025</small>
          <span>12:53</span>
        </div>
        <div class="head-call-time blinking-ringing" *ngIf="call?.callStatus=='RINGING'"
             (click)="callAction('answer')" role="button"  tabindex="-1">
          <img class="icon-call-time" src="/assets/theme/w3crm/icons/svgs/icon-call.svg" alt=""/>
          <button class="btn text-white p-0 pt-0 pb-0 ms-1 mb-1">{{ 'general.answer' | translate }}
          </button>
        </div>

        <div class="head-call-time" *ngIf="call?.callStatus=='ONCALL'" (click)="callAction('hangup')" role="button"  tabindex="-1">
          <img class="icon-call-time" src="/assets/theme/w3crm/icons/svgs/icon-call-time.svg" alt=""/>
          <span><app-call-timer></app-call-timer></span>
          <button class="btn btn-xs btn-danger p-2 pt-0 pb-0 ms-1 mb-1">
            {{ 'general.hangup' | translate }}
          </button>
        </div>
        <div class="head-call-time bg-darked" *ngIf="call?.callStatus=='HANGUP' || !call.callStatus"
             (click)="callAction('make')" role="button"  tabindex="-1">
          <img class="icon-call-time" src="/assets/theme/w3crm/icons/svgs/icon-call-time.svg" alt=""/>
          <span><app-call-timer></app-call-timer></span>
          <button class="btn btn-xs btn-success p-2 pt-0 pb-0 ms-1 mb-1">
            {{ 'general.makecall' | translate }}
          </button>
        </div>

        <div class="head-call-time bg-info" *ngIf="call?.callStatus=='loading'">
          <span class="btn text-white p-0 pt-0 pb-0 ms-1 mb-1">{{ 'general.trying' | translate }}
          </span>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="body">
    <div class="d-flex gap-3 call-card p-3" *ngIf="selectCall && selectCall.callId==call.callId">
      <div [class]="isMinimized ? 'col-md-1 col-12' : 'col-md-2 col-12'">
        <div class="card-tab" [class.minimized]="isMinimized">
          <div class="card-tab-head d-flex-between">
            <div class="title" [class.d-center]="isMinimized">
              <span *ngIf="!isMinimized"> {{ 'call-receiving-popup.related-info'  | translate }}</span>
              <img class="icon-call-time mt-2" src="/assets/theme/w3crm/icons/svgs/minimize-menu.svg" alt=""
                   (click)="toggleRelatedMenu()" *ngIf="isMinimized"/>
            </div>
            <img *ngIf="!isMinimized" (click)="toggleRelatedMenu()" class="card-tab-minimize" alt=""
                 src="/assets/theme/w3crm/icons/svgs/normalize-menu.svg"/>
          </div>

          <div class="card-tab-list">
            <ul [class.minimize]="isMinimized">
              <li *ngFor="let item of relatedMenuItems;let i = index;" [class.active]="selectRelatedTab==item.id"
                  (click)="selectRelatedTab=item.id" role="button"  tabindex="-1">
                <i [innerHtml]="item.svg | safeHtml" class="related-tab-icon"></i>
                <span *ngIf="!isMinimized">{{ item.label | translate }}</span>
                <small class="count"
                       *ngIf="item.id=='patients' && call.possibleRelated?.patients?.length>0">{{ call.possibleRelated?.patients?.length }}</small>
                <small class="count"
                       *ngIf="item.id=='instituations' && call.possibleRelated?.instituations?.length>0">{{ call.possibleRelated?.instituations?.length }}</small>
                <small class="count"
                       *ngIf="item.id=='caseOngoingPatientInformations' &&  call.possibleRelated?.caseOngoingPatientInformations?.length>0">{{ call.possibleRelated?.caseOngoingPatientInformations?.length }}</small>
                <small class="count"
                       *ngIf="item.id=='caseEndedPatientInformations' && call.possibleRelated?.caseEndedPatientInformations?.length>0">{{ call.possibleRelated?.caseEndedPatientInformations?.length }}</small>

              </li>
            </ul>
          </div>
        </div>
      </div>

      <div
        [class]="isMinimized && !isMinimizedResult ? 'col-md-9' :isMinimized && isMinimizedResult?'col-md-10':!isMinimized && isMinimizedResult?'col-md-9':'col-md-8'">
        <div class="card-body gap-3"
             *ngIf="call.possibleRelated[selectRelatedTab] && call.possibleRelated[selectRelatedTab].length>0;else noData">
          <div class="card-item d-grid p-3" [class.active-item]="selectedRelated?.id==item?.id"
               *ngFor="let item of call.possibleRelated[selectRelatedTab];"
               (click)="setRelated(item,selectRelatedTab)" role="button"  tabindex="-1">

            <div class="d-flex-between" *ngIf="selectRelatedTab=='instituations'">
              <strong>#{{ item?.id }} {{ item?.signboard }}</strong>
              <a [routerLink]="['/instituation/list']"
                 [queryParams]="{openSidebar: true,instituationId:item?.id}"
                 target="_blank"
                 class="d-flex-between">
                <span class="text-link me-2 mt-1">{{ 'call-receiving-popup.detail' | translate }}</span>
                <img src="/assets/theme/w3crm/icons/svgs/detail.svg" alt=""/>
              </a>
            </div>

            <div class="d-flex-between align-items-end" *ngIf="selectRelatedTab=='instituations'">
              <div class="d-grid ">
                <div class="d-flex align-items-center">
                  <span class="item-name">{{ item?.title }}</span>
                </div>
                <div class="d-flex mt-2">
                  <small class="item-badge-info">ERP <strong>{{ item?.erpCode }}</strong></small>
                  <small class="item-badge-info ms-1">{{ item?.instituationShortCode }}</small>
                </div>
              </div>

              <div class="d-flex-between align-items-end">
                <span *ngFor="let category of item?.category" class="text-uppercase me-2"
                      [class]="category?.valueObject?.class?.value">{{ category?.valueObject?.name?.value }}</span>
                <div class="item-badge-info pe-2 ps-2">
                  <div class="d-flex-between gap-3">
                    <div class="case-history"><span>0</span><small>Yürüyen Vaka</small></div>
                    <div class="case-history text-light"><span>0</span><small>Biten Vaka</small></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex-between" *ngIf="selectRelatedTab=='patients'">
              <strong>#{{ item?.id }}</strong>
              <a [routerLink]="['/definition/patient/list']" [queryParams]="{openSidebar: true,patientId:item?.id}"
                 target="_blank"
                 class="d-flex-between">
                <span class="text-link me-2 mt-1">{{ 'call-receiving-popup.detail' | translate }}</span>
                <img src="/assets/theme/w3crm/icons/svgs/detail.svg" alt=""/>
              </a>
            </div>

            <div class="d-flex-between"
                 *ngIf="selectRelatedTab=='caseOngoingPatientInformations' || selectRelatedTab=='caseEndedPatientInformations'">
              <strong>#{{ item?.cases?.caseType?.valueObject?.code?.value }}-{{ item?.cases?.caseNo }}
                | {{ item?.cases?.caseType?.valueObject?.name?.value }}</strong>
              <a [routerLink]="['/case/'+item?.cases?.id]" [queryParams]="{openSidebar: true}"
                 target="_blank"
                 class="d-flex-between">
                <span class="text-link me-2 mt-1">{{ 'call-receiving-popup.detail' | translate }}</span>
                <img src="/assets/theme/w3crm/icons/svgs/detail.svg" alt=""/>
              </a>
            </div>


            <div class="d-flex-between align-items-end" *ngIf="selectRelatedTab=='patients'">
              <div class="d-grid ">
                <div class="d-flex align-items-center">
                  <span><img src="/assets/theme/w3crm/icons/svgs/verify.svg" alt=""/></span>
                  <span class="item-name">{{ item?.firstName }} {{ item?.lastName }}</span>
                </div>
                <div class="d-flex mt-2">
                  <small class="item-badge-info">{{ 'gender.' + item?.gender.toLowerCase() | translate }}</small>
                  <small class="item-badge-info ms-1">{{ item.birthDate | dateFormat }}</small>
                </div>
              </div>

              <div class="d-flex-between align-items-end">
                <span *ngFor="let category of item?.category" class="text-uppercase me-2"
                      [class]="category?.valueObject?.class?.value">{{ category?.valueObject?.name?.value }}</span>
                <div class="item-badge-info pe-2 ps-2">
                  <div class="d-flex-between gap-3">
                    <div class="case-history"><span>0</span><small>Yürüyen Vaka</small></div>
                    <div class="case-history text-light"><span>0</span><small>Biten Vaka</small></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex-between align-items-end"
                 *ngIf="selectRelatedTab=='caseOngoingPatientInformations' || selectRelatedTab=='caseEndedPatientInformations'">
              <div class="d-grid ">
                <div class="d-flex align-items-center">
                  <span><img src="/assets/theme/w3crm/icons/svgs/verify.svg" alt=""/></span>
                  <span class="item-name">{{ item?.firstName }} {{ item?.lastName }}</span>
                </div>
                <div class="d-flex mt-2">
                  <small class="item-badge-info ms-1"
                         *ngFor="let diagnose of item?.cases?.caseInformations?.diagnoses">{{ diagnose.icdCode.name }}</small>
                </div>
              </div>

              <div class="d-flex-between align-items-end">
                <span *ngFor="let category of item?.patient?.category" class="text-uppercase me-2"
                      [class]="category?.valueObject?.class?.value">{{ category?.valueObject?.name?.value }}</span>
                <div class="item-badge-info pe-2 ps-2">
                  <div class="d-flex-between gap-3">
                    <div class="case-history">
                      <span>{{ (item?.cases?.createdAt | dateFormat:true).split(" ")[1].substring(0, 5) }}</span><small
                      class="text-break">{{ item?.cases?.createdAt | dateFormat }}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-template #noData>
          <div class="card-body gap-3 text-light">
            {{ 'general.empty-data' | translate }}
          </div>
        </ng-template>
      </div>

      <div [class]="isMinimizedResult ? 'col-md-1' : 'col-md-2'" class="pe-4">
        <div class="card-tab" [class.minimized]="isMinimizedResult">
          <div class="card-tab-head d-flex-between">
            <div class="title" [class.d-center]="isMinimizedResult">
              <span *ngIf="!isMinimizedResult"> {{ 'call-receiving-popup.result-code'  | translate }}</span>
              <img class="icon-call-time mt-2" src="/assets/theme/w3crm/icons/svgs/minimize-menu.svg" alt=""
                   (click)="toggleRelatedMenuResult()" *ngIf="isMinimizedResult"/>
            </div>
            <img *ngIf="!isMinimizedResult" (click)="toggleRelatedMenuResult()" class="card-tab-minimize" alt=""
                 src="/assets/theme/w3crm/icons/svgs/normalize-menu.svg"/>
          </div>
          <div class="card-tab-list result" (ngInit)="setResultCodes()">
            <ul [class.minimize]="isMinimizedResult" id="others">
              <li *ngFor="let item of (resultCodes | filterBy:'other':false) | sort:'sort':'asc';let i = index;"
                  (click)="setCardResultCodeConfirmMessage(item)" role="button"  tabindex="-1">
                <i [innerHtml]="item.icon | safeHtml"></i>
                <span *ngIf="!isMinimizedResult"
                      class="text-lowercase text-capitalize">{{ item.name | translate }}</span>
              </li>
              <li class="other" [class.bg-success]="isOtherResult"
                  (click)="setOtherResult(isOtherResult=!isOtherResult)" role="button"  tabindex="-1">
                <img src="/assets/theme/w3crm/icons/svgs/other-menu.svg" alt=""/>
                <span *ngIf="!isMinimizedResult">{{ 'call-receiving-popup.other' | translate }}</span>
              </li>
              <ng-container *ngIf="isOtherResult">
                <li *ngFor="let item of (resultCodes | filterBy:'other':true) | sort:'sort':'asc';let i = index;"
                    (click)="setCardResultCodeConfirmMessage(item)" role="button"  tabindex="-1">
                  <i [innerHtml]="item.icon | safeHtml"></i>
                  <span *ngIf="!isMinimizedResult"
                        class="text-lowercase text-capitalize">{{ item.name | translate }}</span>
                </li>
              </ng-container>
            </ul>
          </div>
        </div>

        <div class="card-tab mt-3" [class.minimized]="isMinimizedResult">
          <div class="card-tab-head note d-flex-between align-items-center">
            <div class="title" [class.d-center]="isMinimizedResult">

              <img src="/assets/theme/w3crm/icons/svgs/note.svg" alt=""/>
              <strong class="ms-2"
                      *ngIf="!isMinimizedResult"> {{ 'call-receiving-popup.call-note'  | translate }}</strong>

            </div>
          </div>
          <textarea class="form-control card-body border-0 mt-2" placeholder="Notunuz" [(ngModel)]="note"></textarea>


        </div>
      </div>

    </div>
  </ng-template>
</p-dialog>
<app-patient-create #showPatient></app-patient-create>
<core-medical-advice-dialog #medicalAdviceDialog/>
